module.exports = __webpack_public_path__ + "img/ax.53d8edff.svg";